import {ValueRetrieverBase} from "./Core/ValueRetrieverBase";
import {ComparisonTypeEnum} from "../../Fields/Core/ConditionOptions";

export class NoneValueRetriever extends ValueRetrieverBase{
    GetValue() {
        return '';
    }

    Compare(Comparison: ComparisonTypeEnum, Value: any) {
    }

}